import { render, staticRenderFns } from "./recuperacion.vue?vue&type=template&id=d48f1974&scoped=true"
import script from "./recuperacion.vue?vue&type=script&lang=js"
export * from "./recuperacion.vue?vue&type=script&lang=js"
import style0 from "./recuperacion.vue?vue&type=style&index=0&id=d48f1974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48f1974",
  null
  
)

export default component.exports